import { Component, OnInit } from '@angular/core';
import { ClinicService } from 'src/app/_services/clinic.service';
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormArray,
  AbstractControl,
} from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-register-clinic-dialog',
  templateUrl: './register-clinic-dialog.component.html',
  styleUrls: ['./register-clinic-dialog.component.scss'],
})
export class RegisterClinicDialogComponent implements OnInit {
  nurses: any[] = [];
  submitted = false;
  loading = false;
  data: any;
  selectedNurse: any;

  constructor(
    private clinicService: ClinicService,
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private messageService: MessageService,
    public config: DynamicDialogConfig
  ) {}

  clinicForm = this.fb.group({
    name: ['', [Validators.required]],
    professional_nurse: ['', [Validators.required]],
    district: [''],
    address_line_1: [''],
    address_line_2: [''],
    suburb: [''],
    street_address: [''],
    city: [''],
    postal_code: [''],
    province: ['', [Validators.required]],
    user_id: [0],
    credit_limit: [0],
  });

  provinces = [
    { name: 'Gauteng', code: 'GP' },
    { name: 'Western Cape', code: 'WC' },
    { name: 'Eastern Cape', code: 'EC' },
    { name: 'Free State', code: 'FS' },
    { name: 'KwaZulu-Natal', code: 'KZN' },
    { name: 'Limpopo', code: 'LP' },
    { name: 'Mpumalanga', code: 'MP' },
    { name: 'North West', code: 'NW' },
    { name: 'Northern Cape', code: 'NC' },
  ];

  ngOnInit(): void {
    if (this.config.data) {
      this.data = this.config.data.formdata;
    }
    this.clinicService.getAdminNurses().subscribe(
      (response: any) => {
        console.log('Nurses:', response);

        this.nurses = response.body.data.map((nurse: any) => ({
          id: nurse.user.id,
          first_name: nurse.user.first_name,
          last_name: nurse.user.last_name,
          email: nurse.user.email,
        }));

        console.log('Nurses:', this.nurses);

        if (this.data) {
          const matchingNurse = this.nurses.find(
            (n) => n.id === this.data.user_id
          );

          console.log('user_id from data:', this.data.user_id);
          console.log(
            'nurse IDs:',
            this.nurses.map((n) => n.id)
          );

          this.clinicForm.patchValue({
            user_id: this.data.user_id,
            name: this.data.name,
            professional_nurse: this.data.user_id,
            district: this.data.district,
            address_line_1: this.data.address_line_1,
            address_line_2: this.data.address_line_2,
            suburb: this.data.suburb,
            street_address: this.data.street_address,
            city: this.data.city,
            postal_code: this.data.postal_code,
            province: this.data.province,
            credit_limit: this.data.credit_limit, 
          });

          console.log('Clinic Form Data:', this.clinicForm.value);
        }
      },
      (error: any) => {
        console.error('Error fetching users:', error);
      },
      () => {}
    );
  }

  onNurseDropdownChange(event: any) {
    const selectedNurse = this.nurses.find((nurse) => {
      console.log('Nurse', nurse.id);
      console.log('Clinic Form Nurse', event.value);

      return nurse.id === event.value;
    });

    console.log('selectedNurse', selectedNurse);

    if (selectedNurse) {
      this.clinicForm.patchValue({
        user_id: selectedNurse.id,
      });
    }
  }

  onProvinceChange(event: any) {
    console.log(event.value.name);
  }

  closeDialog() {
    this.ref.close();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.clinicForm.controls;
  }

  loadNurses($event: any) {
    console.log('Loading nurses with event:', $event);
    const metaData = {
      limit: $event.rows || 100,
      offset: $event.first || 0,
      globalFilter: $event.filter || '',
    };
    this.clinicService.getAdminNurses(metaData).subscribe(
      (response: any) => {
        this.nurses = response.body.data.map((nurse: any) => ({
          id: nurse.user.id,
          first_name: nurse.user.first_name,
          last_name: nurse.user.last_name,
          email: nurse.user.email,
        }));
      },
      (error) => {
        console.error('Error loading nurses:', error);
      }
    );
  }

  onSubmit() {
    this.submitted = true;
    this.loading = true;
    console.log(this.clinicForm.value);

    // set the professional nurse name in the form

    // mark all fields as touched and dirty
    Object.keys(this.clinicForm.controls).forEach((key) => {
      const control = this.clinicForm.get(key);
      if (control) {
        control.markAsTouched();
        control.markAsDirty();
      }
    });

    if (this.clinicForm.valid) {
      if (this.data) {
        this.clinicService
          .updateClinic(this.data.id, this.clinicForm.value)
          .subscribe(
            (response: any) => {
              console.log(response);
              this.ref.close(response);
              this.loading = false;
            },
            (error: any) => {
              console.error('Error updating clinic:', error);
              this.loading = false;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Clinic update failed. Please try again.',
                key: 'clinicUpdate',
              });
            }
          );
      } else {
        this.clinicService.createClinic(this.clinicForm.value).subscribe(
          (response: any) => {
            console.log(response);
            this.ref.close(response);
            this.loading = false;
          },
          (error: any) => {
            console.error('Error creating clinic:', error);
            this.loading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Clinic creation failed. Please try again.',
              key: 'clinicCreation',
            });
          }
        );
      }
    } else {
      console.log('Form is invalid');
      this.loading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill in all required fields.',
        key: 'clinicCreation',
      });
    }
  }
}
